// @todo find a way to share this js between cross sell, tabbed products and trends
var slidedownVideoPlayer = slidedownVideoPlayer || {};

(function ($) {
  // @todo post launch - get this to work inside the bahavior
  var $videoPlayers = $('body').find('.js-slidedown-video-player');

  $videoPlayers.each(function () {
    var $player = $(this);

    $(document).on('youtubeIframeAPI.loaded', function (e) {
      slidedownVideoPlayer.setup(e, $player);
    });
  });

  Drupal.behaviors.trendsBlockV1 = {
    attach: function (context) {
      var $modules = $('.js-trends-block-v1', context);
      var $grids = $('.js-product-grid', $modules);
      var $carousels = $('.js-product-brief-carousel-items', $grids);
      var rowIsAnmimated = $modules.parents('.homepage-formatter__row').length;

      $carousels.each(function () {
        $this = $(this);
        var $arrowsDiv = $this.parent().find('.carousel-controls');
        var slides_to_show = JSON.parse($this.closest('.js-product-grid').attr('data-grid-items-per-row'));
        var settings = {
          appendArrows: $arrowsDiv,
          infinite: true,
          slidesToShow: slides_to_show.large,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                dots: false,
                slidesToShow: slides_to_show.medium,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 769,
              settings: {
                arrows: true,
                dots: false,
                slidesToShow: slides_to_show.small,
                slidesToScroll: 1
              }
            }
          ]
        };

        // Init this carousel with our settings
        $this.slick(settings);
      });

      if (rowIsAnmimated > 0) {
        $grids.waypoint({
          handler: function (direction) {
            $grids.show();
            $grids.toggleClass('come-in', direction === 'down');
          },
          offset: '93%'
        });
      }
    }
  };
})(jQuery);
